//node-modules
import React, { useState, useEffect } from "react";
//src
import { SxProps, TextField, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../locales/i18n";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

interface Props {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  inputSX: SxProps;
}
/**
 * HOME Job List 検索
 */
export const SearchBox = (props: Props) => {
  const { t, i18n } = useTranslation();
  const [isLanguage, setLanguage] = useState(false);

  useEffect(() => {
    if (i18n.language === "ja") setLanguage(true);
    else setLanguage(false);
  }, [i18n.language]);

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.main,
  };

  return (
    <TextField
      type="input"
      value={props.value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ fontSize: "18px" }} />
          </InputAdornment>
        ),
        sx: {
          paddingTop: 0,
          paddingBottom: 0,
          height: "40px",
          borderRadius: 0,
          ...props.inputSX,
        },
      }}
      onChange={(e) => props.setValue(e.target.value)}
      placeholder={t("PROJECT_SEARCH")}
      variant="outlined"
    />
  );
};

export default SearchBox;
